import { declineCookies, setCookies } from "@/api/CookiesApi";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const CookieConsentPopup = () => {
  const pathname = usePathname();
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    const cookiesList = document.cookie.split(";").reduce((cookies, cookie) => {
      const [name, value] = cookie.split("=").map((c) => c.trim());
      cookies[name] = value;
      return cookies;
    }, {});

    const hasCookie = cookiesList.hasOwnProperty("cookieConsent");
    if (hasCookie) {
      setShowPopup(false);
    }
  }, []);

  const handleAction = (action) => {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 14);
    document.cookie = `cookieConsent=${action}; expires=${expiryDate.toUTCString()};`;
    setShowPopup(false);
    if (action === "accepted") {
      setCookies();
    } else {
      declineCookies();
    }
  };

  return (
    <>
      {pathname === "/blog-header" || pathname === "/blog-footer" ? (
        <></>
      ) : (
        <>
          {showPopup && (
            <div className="fixed bottom-0 left-0 md:left-10 md:bottom-4 bg-white border border-gray-300 p-4 shadow-md z-50 rounded-[4px] w-full md:w-[30rem] text-[0.9rem] popAfterTime">
              <p className="mb-2 ">
                We use cookies to enhance your browsing experience and provide
                personalized content. By clicking "Accept," you agree to our use
                of cookies. Read our{" "}
                <Link href={"/privacy-policy"}>
                  <span className="underline text-red">privacy policy</span>
                </Link>
              </p>

              <div className="w-full flex justify-end items-center md:mt-4">
                <div>
                  <button
                    className="underline mr-2"
                    onClick={() => handleAction("accepted")}
                  >
                    Accept
                  </button>
                  <button
                    className=" px-4 underline "
                    onClick={() => handleAction("declined")}
                  >
                    Decline
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default CookieConsentPopup;
